export enum MagicStructureTriggerTypeEnum {
    ON_FIRST_ACCESS = 'OnFirstAccess',
    NOW = 'Now',
    SCHEDULED_DATE = 'ScheduledDate' // Actually a scheduled date AND time.
}
